module.exports = __webpack_public_path__ + "img/LLUM_120X35.1fbf88fd.png";